import { Metadata_NumberCategory$reflection, Metadata_NumberCategory, Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Title extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "title";
    }
}

export function Title$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Title", void 0, Title, Metadata_StringCategory$reflection());
}

export function Title_$ctor_Z721C83C5(aName) {
    return new Title(aName);
}

export class Collection extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "collection";
    }
}

export function Collection$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Collection", void 0, Collection, Metadata_StringCategory$reflection());
}

export function Collection_$ctor_Z721C83C5(aName) {
    return new Collection(aName);
}

export class IsbnIssn extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "isbn_issn";
    }
}

export function IsbnIssn$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.IsbnIssn", void 0, IsbnIssn, Metadata_StringCategory$reflection());
}

export function IsbnIssn_$ctor_Z721C83C5(aName) {
    return new IsbnIssn(aName);
}

export class Wordcount extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "wordcount";
    }
}

export function Wordcount$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Wordcount", void 0, Wordcount, Metadata_NumberCategory$reflection());
}

export function Wordcount_$ctor_Z721C83C5(aName) {
    return new Wordcount(aName);
}

export class Version extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "version";
    }
}

export function Version$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Version", void 0, Version, Metadata_StringCategory$reflection());
}

export function Version_$ctor_Z721C83C5(aName) {
    return new Version(aName);
}

export class Supcat extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "supcat";
    }
}

export function Supcat$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Supcat", void 0, Supcat, Metadata_StringCategory$reflection());
}

export function Supcat_$ctor_Z721C83C5(aName) {
    return new Supcat(aName);
}

export class Category extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "category";
    }
}

export function Category$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Category", void 0, Category, Metadata_StringCategory$reflection());
}

export function Category_$ctor_Z721C83C5(aName) {
    return new Category(aName);
}

export class Publisher extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "publisher";
    }
}

export function Publisher$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Publisher", void 0, Publisher, Metadata_StringCategory$reflection());
}

export function Publisher_$ctor_Z721C83C5(aName) {
    return new Publisher(aName);
}

export class Pubdate extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "pubdate";
    }
}

export function Pubdate$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Pubdate", void 0, Pubdate, Metadata_NumberCategory$reflection());
}

export function Pubdate_$ctor_Z721C83C5(aName) {
    return new Pubdate(aName);
}

export class Pubplace extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "pubplace";
    }
}

export function Pubplace$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Pubplace", void 0, Pubplace, Metadata_StringCategory$reflection());
}

export function Pubplace_$ctor_Z721C83C5(aName) {
    return new Pubplace(aName);
}

export class CorpusDate extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "corpus_date";
    }
}

export function CorpusDate$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.CorpusDate", void 0, CorpusDate, Metadata_NumberCategory$reflection());
}

export function CorpusDate_$ctor_Z721C83C5(aName) {
    return new CorpusDate(aName);
}

export class Translation extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "translation";
    }
}

export function Translation$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Translation", void 0, Translation, Metadata_StringCategory$reflection());
}

export function Translation_$ctor_Z721C83C5(aName) {
    return new Translation(aName);
}

export class Supclass extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "supclass";
    }
}

export function Supclass$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Supclass", void 0, Supclass, Metadata_StringCategory$reflection());
}

export function Supclass_$ctor_Z721C83C5(aName) {
    return new Supclass(aName);
}

export class Class extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "class";
    }
}

export function Class$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Class", void 0, Class, Metadata_StringCategory$reflection());
}

export function Class_$ctor_Z721C83C5(aName) {
    return new Class(aName);
}

export class Name extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "name";
    }
    ["Shared.Metadata.Category.get_TableName"]() {
        return "authors";
    }
}

export function Name$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Name", void 0, Name, Metadata_StringCategory$reflection());
}

export function Name_$ctor_Z721C83C5(aName) {
    return new Name(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
    ["Shared.Metadata.Category.get_TableName"]() {
        return "authors";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Born extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "born";
    }
    ["Shared.Metadata.Category.get_TableName"]() {
        return "authors";
    }
}

export function Born$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Born", void 0, Born, Metadata_NumberCategory$reflection());
}

export function Born_$ctor_Z721C83C5(aName) {
    return new Born(aName);
}

export class Translator extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "translator_name";
    }
    ["Shared.Metadata.Category.get_TableName"]() {
        return "translators";
    }
}

export function Translator$reflection() {
    return class_type("Corpora.Bokmal.MetadataCategories.Translator", void 0, Translator, Metadata_StringCategory$reflection());
}

export function Translator_$ctor_Z721C83C5(aName) {
    return new Translator(aName);
}

